import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { CampaignDTO } from '../../../core/models/campaignDTO.model';
import { CampaignService } from '../../../core/services/campaign.service';
import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { ShippingPriceDTO } from '../../../core/models/shippingPriceDTO.model';
import { FrontendService } from '../../../service/frontend.service';
import { UIPermissionWrapper } from '../../../model/ui-permission-wrapper.model';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'kt-dialog-campaign',
  templateUrl: './dialog-campaign.component.html',
  styleUrls: ['./dialog-campaign.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ]
})
export class DialogCampaignComponent implements OnInit {

  public permission: UIPermissionWrapper
  campaignDetailForm: FormGroup;
  editEnabled: boolean = false;
  errors: any = [];

  constructor(
    public dialogRef: MatDialogRef<DialogCampaignComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogData,
    private fb: FormBuilder,
    private campaignService: CampaignService,
    private _snackBar: MatSnackBar,
    private frontendService: FrontendService
  ) { }

  ngOnInit() {

    this.permission = this.frontendService
      .permissionFor("views/shared/dialog-campaign/dialog-campaign.component");

    this.initCampaignForm();

  }

  initCampaignForm() {
    let cmp = this.data.campaignData[0];
    let init: Date;
    if(this.data.campaignData[1].length > 0){
        let lastCampaign = this.data.campaignData[1].at(-1);
        init = new Date(lastCampaign.endDate);
        init.setDate(init.getDate() +1);
    }

    this.campaignDetailForm = this.fb.group({
      campaignName: [cmp ? cmp.number : '', Validators.required],
      //facturacion: [this.data.campaignData ? '15' : '', Validators.required],
      pedidoMinimo: [cmp ? cmp.minOrder : '', Validators.required],
      noticeOrderValue: [cmp ? cmp.noticeOrderValue: '', Validators.required],
      bonificacion: [cmp ? cmp.minOrderShipping : '', Validators.required],
      limiteCr1: [cmp ? cmp.firstOrderCredit : '', Validators.required],
      limiteCr2: [cmp ? cmp.secondOrderCredit : '', Validators.required],
      limiteCr3: [cmp ? cmp.thirdOrderCredit : '', Validators.required],
      limiteCr4: [cmp ? cmp.fourthOrderCredit : '', Validators.required],
      limiteCr5: [cmp ? cmp.fifthOrderCredit : '', Validators.required],
      sistIni: [cmp ? cmp.startDate : init, Validators.required],
      sistFin: [cmp ? cmp.endDate : '', Validators.required],
      ctasIni: [cmp ? cmp.startDateCC : init, Validators.required],
      ctasFin: [cmp ? cmp.endDateCC : '', Validators.required],
      piqueoIni: [cmp ? cmp.startDatePick : '', Validators.required],
      piqueoFin: [cmp ? cmp.endDatePick : '', Validators.required],
      costoFlete: new FormArray([
        this.fb.group(
          {
            orderPriceFrom: [0, Validators.required],
            orderPriceTo: [0.01, Validators.required],
            costoFlete: [0, Validators.required]
          }
        )
      ])
    }),

      this.getDataShippingPrice();

    //this.colorPrimary = (this.data.campaignData ? this.data.campaignData.primaryColor : '#FAFAFA');
    //this.colorSecundary = (this.data.campaignData ? this.data.campaignData.secundaryColor : '#222222');
    this.campaignDetailForm.controls['campaignName'].disable();
    //this.campaignDetailForm.controls['facturacion'].disable();
    this.campaignDetailForm.controls['pedidoMinimo'].disable();
    this.campaignDetailForm.controls['noticeOrderValue'].disable();
    this.campaignDetailForm.controls['bonificacion'].disable();
    this.campaignDetailForm.controls['limiteCr1'].disable();
    this.campaignDetailForm.controls['limiteCr2'].disable();
    this.campaignDetailForm.controls['limiteCr3'].disable();
    this.campaignDetailForm.controls['limiteCr4'].disable();
    this.campaignDetailForm.controls['limiteCr5'].disable();
    this.campaignDetailForm.controls['sistIni'].disable();
    this.campaignDetailForm.controls['sistFin'].disable();
    this.campaignDetailForm.controls['ctasIni'].disable();
    this.campaignDetailForm.controls['ctasFin'].disable();
    this.campaignDetailForm.controls['piqueoIni'].disable();
    this.campaignDetailForm.controls['piqueoFin'].disable();
    this.campaignDetailForm.controls['costoFlete'].disable();

    if (!this.data.campaignData[0]) {
      if (this.data.campaignData[1].length > 0) {
        let aux = this.data.campaignData[1][this.data.campaignData[1].length - 1].number;
        let aux2 = aux.split('/');
        aux2[0] = parseInt(aux2[0], 10) + 1;
        this.campaignDetailForm.controls['campaignName'].setValue(aux2[0] + '/' + aux2[1]);
      } else {
        this.campaignDetailForm.controls['campaignName'].setValue(1 + '/' + this.data.campaignData[2]);
      }
      this.enabledInputs();
    }
  }

  public getDataShippingPrice(): void {
    if (this.data.campaignData[0] != null && this.data.campaignData[0].shippingPriceList.length > 0) {
      this.deleteCostoFlete(0, false)
      this.data.campaignData[0].shippingPriceList.forEach(sp => {
        const costoFleteData = this.fb.group({
          orderPriceFrom: [sp.priceFrom, Validators.required],
          orderPriceTo: [sp.priceTo, Validators.required],
          costoFlete: [sp.shippingPrice, Validators.required]
        })
        this.getCostosFlete().push(costoFleteData)
      });
    }
  }

  public getCostosFlete(): FormArray {
    return this.campaignDetailForm.get('costoFlete') as FormArray;
  }

  public addCostoFlete(): void {

    let fromValue = 0;
    let costoFlete = 0;

    let controlsFlete = this.getCostosFlete();

    const i = controlsFlete.length - 1;

    if (i >= 0) {
      fromValue = parseFloat(controlsFlete.value[i].orderPriceTo);
      costoFlete = controlsFlete.value[i].costoFlete;
    }

    const newCostoFleteGroup = this.fb.group({
      orderPriceFrom: [fromValue + 0.01, Validators.required],
      orderPriceTo: [fromValue + 1, Validators.required],
      costoFlete: [0, Validators.required]
    })

    this.getCostosFlete().push(newCostoFleteGroup)
  }

  updateValueFrom(i: number) {
    const valueFrom = parseFloat(this.getCostosFlete().at(i).get('orderPriceFrom').value)

    if (parseFloat(this.getCostosFlete().at(i).get('orderPriceTo').value) <= valueFrom) {
      this.getCostosFlete().at(i).get('orderPriceTo').setValue(valueFrom + 1)
    }
    this.verifyConsistence();
  }

  updateValueTo(i: number) {
    const valueTo = parseFloat(this.getCostosFlete().at(i).get('orderPriceTo').value)

    if (parseFloat(this.getCostosFlete().at(i).get('orderPriceFrom').value) >= valueTo) {
      this.getCostosFlete().at(i).get('orderPriceFrom').setValue(valueTo - 1)
    }
    this.verifyConsistence();
  }

  public deleteCostoFlete(lessonIndex: number, fromHtml = true): void {
    this.getCostosFlete().removeAt(lessonIndex);
    if (fromHtml) {
      this.verifyConsistence();
    }
  }

  public verifyConsistence(): void {
    if (this.getCostosFlete().at(0).get('orderPriceFrom').value != 0) {
      this.getCostosFlete().at(0).get('orderPriceFrom').setValue(0)
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  enabledInputs() {
    if (this.data.campaignData[0]) {
      this.campaignService.getZones(this.data.campaignData[0].id).subscribe(res => {
        if (res.length === 0) {
          this.campaignDetailForm.controls['sistIni'].enable();
          this.campaignDetailForm.controls['sistFin'].enable();
          this.campaignDetailForm.controls['ctasIni'].enable();
          this.campaignDetailForm.controls['ctasFin'].enable();
          this.campaignDetailForm.controls['piqueoIni'].enable();
          this.campaignDetailForm.controls['piqueoFin'].enable();
        }
      });
    } else {
      this.campaignDetailForm.controls['sistIni'].enable();
      this.campaignDetailForm.controls['sistFin'].enable();
      this.campaignDetailForm.controls['ctasIni'].enable();
      this.campaignDetailForm.controls['ctasFin'].enable();
      this.campaignDetailForm.controls['piqueoIni'].enable();
      this.campaignDetailForm.controls['piqueoFin'].enable();
    }

    // this.campaignDetailForm.controls['campaignName'].enable();
    //this.campaignDetailForm.controls['facturacion'].enable();
    this.campaignDetailForm.controls['pedidoMinimo'].enable();
    this.campaignDetailForm.controls['noticeOrderValue'].enable();
    this.campaignDetailForm.controls['costoFlete'].enable();
    this.campaignDetailForm.controls['limiteCr1'].enable();
    this.campaignDetailForm.controls['limiteCr2'].enable();
    this.campaignDetailForm.controls['limiteCr3'].enable();
    this.campaignDetailForm.controls['limiteCr4'].enable();
    this.campaignDetailForm.controls['limiteCr5'].enable();
    this.getCostosFlete().controls.slice(1).forEach(cf => cf.enable());
    this.editEnabled = true;

  }

  saveCampaign() {

    this.errors = [];
    const controls = this.campaignDetailForm.controls;
    if (this.campaignDetailForm.invalid) {
        Object.keys(controls).forEach(controlName => {
        controls[controlName].markAsTouched();
        });
        return;
    }
    this.errors = this.checkErrors();
    console.log(this.errors);

    if (this.errors.length > 0) {
      this.openSnackBar(this.errors[0], 'Close');
      return;
    }

    let campaign = new CampaignDTO();
    campaign.number = this.campaignDetailForm.controls['campaignName'].value;
    campaign.startDate = this.campaignDetailForm.controls['sistIni'].value;
    campaign.endDate = this.campaignDetailForm.controls['sistFin'].value;
    campaign.startDateCC = this.campaignDetailForm.controls['ctasIni'].value;
    campaign.endDateCC = this.campaignDetailForm.controls['ctasFin'].value;
    campaign.startDatePick = this.campaignDetailForm.controls['piqueoIni'].value;
    campaign.endDatePick = this.campaignDetailForm.controls['piqueoFin'].value;
    campaign.minOrder = this.campaignDetailForm.controls['pedidoMinimo'].value;
    campaign.noticeOrderValue = this.campaignDetailForm.controls['noticeOrderValue'].value;
    campaign.firstOrderCredit = this.campaignDetailForm.controls['limiteCr1'].value;
    campaign.secondOrderCredit = this.campaignDetailForm.controls['limiteCr2'].value;
    campaign.thirdOrderCredit = this.campaignDetailForm.controls['limiteCr3'].value;
    campaign.fourthOrderCredit = this.campaignDetailForm.controls['limiteCr4'].value;
    campaign.fifthOrderCredit = this.campaignDetailForm.controls['limiteCr5'].value;
    campaign.shippingPriceList = new Array<ShippingPriceDTO>();

    this.getCostosFlete().controls.forEach(spl => {
      let shippingPrice = new ShippingPriceDTO(spl.value.orderPriceFrom, spl.value.orderPriceTo, spl.value.costoFlete);
      campaign.shippingPriceList.push(shippingPrice);
    });

    campaign.status = "Active";

    if (!this.data.campaignData[0]) {
      this.campaignService.saveCampaign(campaign).subscribe(
        response => {
          this.dialogRef.close(true);
          this.openSnackBar("Campaña guardada con éxito", "Ok")
        },
        (error : HttpErrorResponse) => {
            console.log("error ahora", error);
          this.errors.push("La campaña no se pudo registrar");
        });
    } else {
      campaign.id = this.data.campaignData[0].id;
      this.campaignService.updateCampaign(campaign).subscribe(
        response => {
            console.log("response ", response);
            this.dialogRef.close(true);
            this.openSnackBar("Campaña modificada con éxito", "Ok");
          },
        (error : HttpErrorResponse) => {
            console.log("error ahora", error);
            if(error.error == null){
                this.errors.push("La campaña no se pudo modificar");
            } else{
                this.errors.push(error.error);
            }
        });
    }
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.campaignDetailForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  getCampaignByFind(id) {
    return this.data.campaignData[1].findIndex(x => x.id === id);
  }

  checkDates(index) {
    let errors = [];
    if (index) {
      let auxAnterior = null;
      if (index != 0 || this.data.campaignData[1].length == 1) {
        auxAnterior = this.data.campaignData[1][index - 1];
      }

      let auxSiguiente = null;
      if (this.data.campaignData[1].length >= index + 1) {
        auxSiguiente = this.data.campaignData[1][index + 1];
      }

      if (auxSiguiente) {
        let dateSistIni = new Date(this.campaignDetailForm.controls['sistIni'].value);
        let dateCCIni = new Date(this.campaignDetailForm.controls['ctasIni'].value);
        let datePickIni = new Date(this.campaignDetailForm.controls['piqueoIni'].value);
        let dateSistFin = new Date(this.campaignDetailForm.controls['sistFin'].value);
        let dateCCFin = new Date(this.campaignDetailForm.controls['ctasFin'].value);
        let datePickFin = new Date(this.campaignDetailForm.controls['piqueoFin'].value);
        let nextDateSist = new Date(auxSiguiente.startDate);
        let nextDateCC = new Date(auxSiguiente.startDateCC);
        let nextDatePick = new Date(auxSiguiente.startDatePick);

        if (dateSistIni >= nextDateSist || dateCCIni >= nextDateCC ||
          datePickIni >= nextDatePick) {
          errors.push('Una de las fechas de inicio se superpone con la campaña siguiente. ');
        }
        if (dateSistFin >= nextDateSist || dateCCFin >= nextDateCC ||
          datePickFin >= nextDatePick) {
          errors.push('Una de las fechas de fin se superpone con la campaña siguiente. ');
        }
      }

      if (auxAnterior) {
        let dateSist = new Date(this.campaignDetailForm.controls['sistIni'].value);
        let dateCC = new Date(this.campaignDetailForm.controls['ctasIni'].value);
        let datePick = new Date(this.campaignDetailForm.controls['piqueoIni'].value);
        let prevDateSist = new Date(auxAnterior.endDate);
        let prevDateCC = new Date(auxAnterior.endDateCC);
        let prevDatePick = new Date(auxAnterior.endDatePick);

        if (dateSist <= prevDateSist || dateCC <= prevDateCC ||
          datePick <= prevDatePick) {
          errors.push('Una de las fechas de inicio se superpone con la campaña anterior. ');
        }
      }
    }

    if (!index) {
      if (this.data.campaignData[1].length > 0) {
        let auxAnterior = this.data.campaignData[1][this.data.campaignData[1].length - 1];
        let dateSist = new Date(this.campaignDetailForm.controls['sistIni'].value);
        let dateCC = new Date(this.campaignDetailForm.controls['ctasIni'].value);
        let datePick = new Date(this.campaignDetailForm.controls['piqueoIni'].value);
        let prevDateSist = new Date(auxAnterior.endDate);
        let prevDateCC = new Date(auxAnterior.endDateCC);
        let prevDatePick = new Date(auxAnterior.endDatePick);

        if (dateSist <= prevDateSist || dateCC <= prevDateCC ||
          datePick <= prevDatePick) {
          errors.push('Una de las fechas de inicio se superpone con la campaña anterior. ');
        }
      }
    }
    return errors;
  }

  checkErrors() {
    let index = null;
    let errors = [];

    if (this.data.campaignData[0]) {
      index = this.getCampaignByFind(this.data.campaignData[0].id);
    }
    errors = this.checkDates(index);
    return errors;
  }
}


export interface DialogData {
  campaignData: CampaignDTO;
}
